import { combineReducers } from 'redux';

import {
  normalizePurchase,
} from './schemas';
import {
  FETCH_PURCHASE,
} from '../actions/index';

const addConsumerFieldValuesFromPurchase = (state, action) => {
  const { payload } = action;
  const { entities: { consumerFieldValues } } = normalizePurchase(payload);

  return {
    ...state,
    ...consumerFieldValues,
  };
};

const consumerFieldValuesById = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PURCHASE:
      return addConsumerFieldValuesFromPurchase(state, action);
    default:
      return state;
  }
};

export default combineReducers({
  byId: consumerFieldValuesById,
});



// WEBPACK FOOTER //
// ./src/reducers/consumer-field-values.reducer.js